import React from "react";
import LandingPageHeader from "./sections/LandingPageHeader";
import LandingPageFooter from "./sections/LandingPageFooter";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import AIPoweredLearning from "./sections/AIPoweredLearning";
import InteractiveModules from "./sections/InteractiveModules";
import FeedbackAndScaffolding from "./sections/FeedbackAndScaffolding";
import AdvancedCourseManagement from "./sections/AdvancedCourseManagement";
import Contact from "./sections/Contact";
import "./LandingPage.css";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <LandingPageHeader />
      <Hero />
      <Features />
      <AIPoweredLearning />
      <InteractiveModules />
      <FeedbackAndScaffolding />
      <AdvancedCourseManagement />
      <Contact />
      <LandingPageFooter />
    </div>
  );
};

export default LandingPage;
